/**
 * The territory's names on the Zone map (`components/zone/ZoneMap.tsx`), set
 * in italic over the painted raster (`scripts/media/render-territory.mjs`).
 * Italian proper nouns in both locales, like the comuni. The layout of the
 * comuni names treats each as an obstacle, so they stay legible.
 *
 * `lon`/`lat` is the label's anchor point (the text baseline), read from
 * OpenStreetMap with `render-territory.mjs --landmarks` (2026-09-25; the
 * Vercellese frame, Lozzolo to the Po, 2026-09-28):
 * - Canale Cavour: beside its diagonal run south-east of Santhià, turned to
 *   follow it (least-squares fit of the OSM way, lat 45.30–45.36: −52° in
 *   km-true frame units, so any frame of this projection keeps the angle);
 * - Bosco della Partecipanza: over the Parco naturale del Bosco delle Sorti
 *   della Partecipanza di Trino;
 * - Lame del Sesia: centre of the Parco naturale delle Lame del Sesia;
 * - Parco del Po: on the Po below Trino (Parco naturale del Po piemontese),
 *   raised ~1 km to stay clear of the frame's bottom edge;
 * - Baraggia: inside the Riserva naturale delle Baragge (OSM bbox 8.114–8.465 E,
 *   45.48–45.655 N), on its Vercelli side between Roasio and Rovasenda, inside
 *   the provincial border.
 */
export interface Landmark {
  key: string
  name: string
  lon: number
  lat: number
  anchor?: 'start' | 'middle' | 'end'
  /** Degrees, clockwise, about the anchor. */
  rotate?: number
}

export const LANDMARKS: readonly Landmark[] = [
  { key: 'cavour', name: 'Canale Cavour', lon: 8.1778, lat: 45.3135, rotate: -52 },
  { key: 'partecipanza', name: 'Bosco della Partecipanza', lon: 8.2297, lat: 45.223 },
  { key: 'lame', name: 'Lame del Sesia', lon: 8.396, lat: 45.418 },
  { key: 'po', name: 'Parco del Po', lon: 8.3261, lat: 45.166 },
  { key: 'baraggia', name: 'Baraggia', lon: 8.3355, lat: 45.5739 },
]
